import React, { useState, useEffect } from 'react';
import { GET_LIST, Responsive, useDataProvider } from 'react-admin';
import { makeStyles } from '@material-ui/core';
import UnprocessedIdDocuments from './UnprocessedIdDocuments';
import UsersOnWatchlist from './UsersOnWatchlist';

const useStyles = makeStyles({
	flex: {
		display: 'flex',
		marginTop: '1em',
	},
	leftCol: {
		flex: 1,
		marginRight: '1em',
		marginBottom: '2em'
	},
	rightCol: {
		flex: 1,
		marginLeft: '1em',
		marginBottom: '2em'
	},
});

const Dashboard = ({ version }) => {
	const dataProvider = useDataProvider();
	const classes = useStyles();
	const [unprocessedIdDocuments, setUnprocessedIdDocuments] = useState([]);
	const [usersOnWatchlist, setUsersOnWatchList] = useState([]);
	useEffect(() => {
		const fetchUnprocessedIdDocuments = async () => {
			try {
				const { data: unprocessedIdDocuments } = await dataProvider(GET_LIST, 'idDocuments', {
					filter: {
						unprocessed: true
					},
					pagination: {
						page: 1,
						perPage: 50
					}
				});
				setUnprocessedIdDocuments(unprocessedIdDocuments);
			} catch (_) {
				// ignore
			}
		}
		const fetchUsersOnWatchlist = async () => {
			try {
				const { data: usersOnWatchlist } = await dataProvider(GET_LIST, 'users', {
					filter: {
						isOnWatchList: true
					},
					pagination: {
						page: 1,
						perPage: 50
					}
				});
				setUsersOnWatchList(usersOnWatchlist);
			} catch (_) {
				// ignore
			}
		}
		fetchUnprocessedIdDocuments();
		fetchUsersOnWatchlist();
	}, [version, dataProvider]);

	return (
		<Responsive
			medium={
				<div className={classes.flex}>
					<div className={classes.leftCol}>
						<UnprocessedIdDocuments value={unprocessedIdDocuments} />
					</div>
					<div className={classes.rightCol}>
						<UsersOnWatchlist value={usersOnWatchlist} />
					</div>
				</div>
			}
		/>
	);
};

export default Dashboard;
